import React from 'react'
// components
import ResponseTypeSelect, { ResponsiveSelectProps } from 'components/FormElements/ResponseTypesSelect'
// types
import { Field } from 'redux-form'
import { WrappedFieldProps } from 'redux-form/lib/Field'

const Component: React.FC<WrappedFieldProps & Omit<ResponsiveSelectProps, 'onChange'>> = ({
  input,
  meta: { touched, error },
  ...props
}) => {
  const isError = touched && error

  return <ResponseTypeSelect isError={isError} onChange={input.onChange} value={input.value} {...props} />
}

const ReduxResponseTypeSelect: React.FC<Omit<ResponsiveSelectProps, 'onChange'> & { name: string }> = (props) => (
  <Field {...props} component={Component} />
)

export default ReduxResponseTypeSelect
